<template>
	<div class="about container">
		<article class="article-content" ref="article">
			<div id="article-intro" class="article-block">
				<div class="article-intro-text">
					<Heading
						text="About Me"
						accent
						shuffle
						spaced
						loop
						glow
						type="h1"
					/>
					<div class="text-block">
						<Heading
							text="Hello World"
							type="h2"
							class="h1"
							glow
							spaced
						></Heading>
						<!-- <p class="lead">
            I am an experienced 
          </p> -->
					</div>
				</div>
				<div class="article-portraits">
					<div class="portrait-frames">
						<img
							v-for="(portrait, index) in portraits"
							:key="index"
							:src="portrait.src"
							:alt="portrait.alt"
							class="portrait-frame"
						/>
					</div>
				</div>
			</div>

			<div id="article-services" class="article-block">
				<div class="article-body">
					<div class="bio">
						<p class="lead">
							I am a front-end & creative developer who thrives
							with blending creativity with technology. Working
							with a wide range of clients and agencies, I've
							offered both design and technological services to
							projects both large and small. These projects can
							span from websites, to applications, inventory
							portals, creative technologies and bringing
							interactions to designs.
						</p>
						<p class="lead">
							With a passion for video editing at a young age, I
							have always been interested in creating visual
							experiences for people. I have grown to love
							tinkering with technology in order to create these
							experiences. I love seeing positive responses to
							projects I work on and love thinking of new ways to
							make them.
						</p>
						<p class="lead">
							My goal is to work on projects that create unique
							and immersive experiences that push the boundaries
							of traditional interactions.
						</p>
					</div>

					<div class="resume">
						<div class="resume-item resume__services">
							<Heading
								text="Core Services"
								type="h4"
								class="h5"
								spaced
							></Heading>
							<ul>
								<li>Front-End Dev</li>
								<li>Interactive Dev</li>
								<li>UI / UX Design</li>
								<li>Creative Dev</li>
								<li>SEO Optimization</li>
								<li>CMS Dev & Management</li>
								<li>SaaS Dev</li>
								<li>Web App Dev</li>
							</ul>
						</div>
						<div class="resume-item resume__experience">
							<Heading
								text="Experience"
								type="h4"
								class="h5"
								spaced
							></Heading>
							<ul>
								<li>
									<span><i>2021 - Current</i></span>
									<Heading
										text="tbk Creative - Intermediate Front-End
									Developer"
										type="h6"
									></Heading>
								</li>
								<li>
									<span><i>2020 - 2021</i></span>
									<Heading
										text="Polymath Innovations - Fullstack Developer"
										type="h6"
									></Heading>
								</li>
								<li>
									<span><i>2017 - 2020</i></span>

									<Heading
										text="Branton - Web Designer & Developer"
										type="h6"
									></Heading>
								</li>
								<li>
									<span><i>2017 - 2021</i></span>

									<Heading
										text="Freelance Developer"
										type="h6"
									></Heading>
								</li>
							</ul>
						</div>
					</div>
					<div class="brands">
						<Heading
							text="Brands & Agencies I've Worked With"
							type="h4"
							class="h5"
							spaced
						></Heading>
						<div class="brand-logos">
							<div
								v-for="(brand, index) in brandLogos"
								:key="index"
								class="logo"
							>
								<span>{brand.title}</span>
								<img :src="brand.src" :alt="brand.title" />
							</div>
						</div>
					</div>
					<div class="tools">
						<Heading
							text="My Toolbox"
							type="h1"
							class="h5"
							spaced
						></Heading>
						<ul>
							<li>
								<IndexTitle text="Vue" index="01" type="h6" />
							</li>
							<li>
								<IndexTitle text="React" index="02" type="h6" />
							</li>
							<li>
								<IndexTitle
									text="TypeScript"
									index="03"
									type="h6"
									caption=""
								/>
							</li>
							<li>
								<IndexTitle
									text="SVG Animations"
									index="03"
									type="h6"
								/>
							</li>
							<li>
								<IndexTitle
									text="Adobe Suite"
									index="04"
									type="h6"
								/>
							</li>
							<li>
								<IndexTitle text="GSAP" index="05" type="h6" />
							</li>
							<li>
								<IndexTitle
									text="Tailwind"
									index="06"
									type="h6"
								/>
							</li>
							<li>
								<IndexTitle
									text="Laravel"
									index="07"
									type="h6"
								/>
							</li>
							<li>
								<IndexTitle text="MySQL" index="07" type="h6" />
							</li>
							<li>
								<IndexTitle
									text="Wordpress"
									index="08"
									type="h6"
								/>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</article>
		<CallToAction
			title="Projects"
			:text="`A collection of my work bringing brands and creative visions to life, from small
					to large scale. A wide range from interactive Web, to
					Enterprise solutions, to self-made projects.`"
			href="/projects"
			buttonLabel="View Projects"
		/>
	</div>
</template>

<script>
import Heading from '@/components/Heading';
import IndexTitle from '@/components/IndexTitle';
import CallToAction from '@/components/CallToAction';
import { ref, watch, onMounted, onUnmounted } from 'vue';
import { gsap } from 'gsap';
import { useTransitionComposable } from '../../composables/transition-composable';
const { transitionState } = useTransitionComposable();

const portraitImg1 = {
	src: require('@/assets/portraits/lucas-mccallum-portrait-1.jpg'),
	alt: 'Lucas McCallum - Headshot Picture',
};

const portraitImg2 = {
	src: require('@/assets/portraits/lucas-mccallum-portrait-2.jpg'),
	alt: 'Lucas McCallum - Beach Picture',
};

const portraitImg3 = {
	src: require('@/assets/portraits/lucas-mccallum-portrait-3.jpg'),
	alt: 'Lucas McCallum - Fun Picture',
};

const brands = [
	{
		title: '3M',
		src: require('@/assets/logos/3m-logo.png'),
	},
	{
		title: 'tbk Creative',
		src: require('@/assets/logos/tbk-logo-white.svg'),
	},
	{
		title: 'Branton',
		src: require('@/assets/logos/branton-logo.svg'),
	},
	{
		title: 'Polymath Innovation',
		src: require('@/assets/logos/polymath-logo.svg'),
	},
	{
		title: "Heeman's",
		src: require('@/assets/logos/logo-heeman.svg'),
	},
	{
		title: 'Oxford Learning',
		src: require('@/assets/logos/oxford-logo-white-english.svg'),
	},
	{
		title: 'Comment Magazine',
		src: require('@/assets/logos/Comment-Logo.svg'),
	},
	{
		title: 'Dante',
		src: require('@/assets/logos/dante-inferno-logo.svg'),
	},
	{
		title: 'Baylor University',
		src: require('@/assets/logos/BU-Logo.svg'),
	},
	{
		title: 'McCormick',
		src: require('@/assets/logos/mccormick.png'),
	},
	{
		title: 'Dasco Storage Solutions',
		src: require('@/assets/logos/dasco-logo.svg'),
	},
	{
		title: 'Harrison Pensa',
		src: require('@/assets/logos/hp-logo.svg'),
	},
	{
		title: 'Fuzion Flooring',
		src: require('@/assets/logos/fuzion-logo.svg'),
	},
	{
		title: 'Wolverine Insurance',
		src: require('@/assets/logos/wolvering-insurance-logo.svg'),
	},
	{
		title: 'Fanshawe College',
		src: require('@/assets/logos/fanshawe-logo.png'),
	},
	{
		title: 'Vascular Care Group',
		src: require('@/assets/logos/vascular-care-group-logo.svg'),
	},
	{
		title: 'Calian',
		src: require('@/assets/logos/calian-logo.svg'),
	},
	{
		title: 'TechAlliance',
		src: require('@/assets/logos/techalliance-logo.svg'),
	},
];
export default {
	name: 'About',
	components: {
		Heading,
		IndexTitle,
		CallToAction,
	},
	data() {
		return {
			portraits: [portraitImg1, portraitImg2, portraitImg3],
			brandLogos: brands,
		};
	},
	setup() {
		const main = ref();
		const article = ref(null);
		const viewable = ref(false);
		let tl = ref();
		let ctx = ref();
		watch(
			[() => transitionState.transitionComplete, article],
			(newValue) => {
				if (newValue[0] == true && article.value) {
					ctx = gsap.context(() => {
						const el = article.value;
						const portraitImages = el.querySelectorAll(
							'.portrait-frames img',
						);

						tl.value = gsap.timeline();
						tl.value.to(el.querySelector('.article-block h1'), {
							yPercent: 40,
							scrollTrigger: {
								invalidateOnRefresh: true,
								trigger: el.querySelector('#article-intro'),
								start: '-30% -30%', // when the top of the trigger hits the top of the viewport
								scrub: true, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
							},
						});

						let mm = gsap.matchMedia();
						mm.add(
							{
								isTablet: '(min-width: 768px)',
							},
							() => {
								tl.value = gsap.timeline({
									scrollTrigger: {
										trigger:
											el.querySelector(
												'#article-services',
											),
										start: 'top 70%',
										end: 'bottom bottom',
										scrub: 1,
									},
								});

								portraitImages.forEach((portraitImage) => {
									tl.value.fromTo(
										portraitImage,
										{ display: 'none', opacity: 0 },
										{
											display: 'block',
											opacity: 1,
											duration: 0.2,
										},
									);
								});
							},
						);
					}, main.value);
				}
			},
			{
				immediate: true,
			},
		);
		onMounted(() => {
			let mm = gsap.matchMedia();
			mm.add(
				{
					isDesktop: `(min-width: 1400px)`,
					isTablet: '(min-width: 768px)',
				},
				(context) => {
					let { isDesktop } = context.conditions;
					const csTl = gsap.timeline();
					csTl.fromTo(
						'.article-intro h1',
						{ y: 100, opacity: 0 },
						{
							y: isDesktop ? 50 : 20,
							opacity: 0.15,
							duration: 1,
						},
					);

					csTl.fromTo(
						'.article-intro h2',
						{ y: 70, opacity: 0 },
						{
							y: 0,
							opacity: 1,
							duration: 1,
						},
						'-=0.85',
					);
				},
			);
		});
		onUnmounted(() => {
			ctx.revert(); // <- Easy Cleanup!
			tl.value.kill();
		});
		return { article, viewable }; // WILL NOT WORK WITHOUT THIS
	},
	metaInfo: {
		title: 'About Me',
		meta: [
			{
				name: 'description',
				content: `A deeper biography on Lucas' and his resume, approach, clients he has worked with and goals he wishes to accomplish in this field.`,
			},
		],
	},
};
</script>

<style lang="scss"></style>
